import React from 'react';

interface AuroraBackgroundProps {
  variant?: 'default' | 'intense' | 'subtle';
  showStars?: boolean;
  children?: React.ReactNode;
}

const AuroraBackground: React.FC<AuroraBackgroundProps> = ({ 
  variant = 'default', 
  showStars = true,
  children 
}) => {
  return (
    <div className="min-h-screen bg-hawk-dark relative overflow-hidden">
      {/* Aurora Background Effect */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className={`absolute -top-1/2 -left-1/2 w-full h-full bg-gradient-conic from-teal-500/20 via-aurora-green/30 to-teal-400/20 animate-spin-slow rounded-full ${
          variant === 'intense' ? 'opacity-80' : variant === 'subtle' ? 'opacity-40' : 'opacity-60'
        }`}></div>
        <div className={`absolute -bottom-1/2 -right-1/2 w-full h-full bg-gradient-conic from-aurora-green/20 via-teal-400/30 to-emerald-500/20 animate-spin-reverse rounded-full ${
          variant === 'intense' ? 'opacity-60' : variant === 'subtle' ? 'opacity-30' : 'opacity-40'
        }`}></div>
      </div>
      
      {/* Starfield Effect */}
      {showStars && (
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="stars-small"></div>
          <div className="stars-medium"></div>
          <div className="stars-large"></div>
        </div>
      )}

      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default AuroraBackground;